import { render, staticRenderFns } from "./LoginNewPassword.vue?vue&type=template&id=2c3a5e86&scoped=true&"
import script from "./LoginNewPassword.vue?vue&type=script&lang=js&"
export * from "./LoginNewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a5e86",
  null
  
)

export default component.exports